import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren
} from '@angular/core';
import { CommonModule, formatDate } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { ProductService } from 'app/services/product/product.service';
import { ProductDayPickerModalComponent } from '../../productSearch/product-day-picker-modal/product-day-picker-modal.component';
import { ImageFallbackDirective } from 'app/modules/admin/directives/ImageFallbackDirective';
import { ImageUrlPipe } from 'app/modules/admin/pipe/image-url.pipe';
import { ConfirmModalComponent } from 'app/modules/utils/confirm-modal/confirm-modal.component';
import { buildPrintDocument } from 'app/modules/utils/print-modal/print-document';
import { PrintColumn, PrintModalComponent } from 'app/modules/utils/print-modal/print-modal.component';
import { forEach } from 'lodash';
import { MAT_MENU_SCROLL_STRATEGY_FACTORY_PROVIDER } from '@angular/material/menu';

// interface ProductMenuDaySchedule {
//   menu_day_id: number;
//   start_time: string;
//   end_time: string;
//   priority: number;
//   is_active: boolean;
// }
interface ProductMenuDaySchedule {

  menu_day_id: number;

  start_time: string;

  end_time: string;


  // ✅ جديد
  min_qty: number;

  prod_qty: number;

  max_qty: number;

  alloc_qty: number;


  priority: number;

  is_active: boolean;
}

interface PickerSavedPayload {
  day?: number;
  days?: number[];
  menu_days?: ProductMenuDaySchedule[];
  items: Array<{
    product_id: number;
    value: number;
  }>;
}


interface ProductMenuDayForPrint {

  product_name: string;

  product_code: number;

  days_quantity_sat:number;

  days_quantity_sun:number;

  days_quantity_mon:number;

  days_quantity_tues:number;

  days_quantity_wed:number;

  days_quantity_thurs:number;

  days_quantity_fri:number;

}


@Component({
  selector: 'app-menuedays',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    ProductDayPickerModalComponent,
    ConfirmModalComponent,
    ImageFallbackDirective,
    ImageUrlPipe,
    PrintModalComponent
  ],
  templateUrl: './menuedays.component.html',
  styleUrl: './menuedays.component.scss'
})
export class MenuedaysComponent implements OnInit, OnDestroy {
  private readonly saveSubject = new Subject<any>();
  private readonly destroy$ = new Subject<void>();

  isLoading = false;
  pickerOpen = false;

  //popup Modal variables
  showModalItem: boolean = false;
  showModalAll: boolean = false;
  showModalConfirm: boolean = false;

  popupModalArgs = {
    'title': "Delete this user?",
    'message': "This removes their access immediately and can't be undone.",
    'confirmLabel': "Delete user",
    'cancelLabel': "Keep user"
  }
  confirmDelete: boolean = false;
  showPrintModal: boolean = false;

  columns: PrintColumn[] = [
    {
      'key': "product_name",
      'header': "Product Name"
    },
    {
      'key': "product_code",
      'header': "Barcode"
    },
    {
      'key': "days_quantity_sat",
      'header': "Saturday"
    },
    {
      'key': "days_quantity_sun",
      'header': "Sunday"
    },
    {
      'key': "days_quantity_mon",
      'header': "Monday"
    },
    {
      'key': "days_quantity_tues",
      'header': "Tuesday"
    },
    {
      'key': "days_quantity_wed",
      'header': "Wednesday"
    },
    {
      'key': "days_quantity_thurs",
      'header': "Thursday"
    },
    {
      'key': "days_quantity_fri",
      'header': "Friday"
    },
  ]


  ordersPrint: ProductMenuDayForPrint[] = [];

  products: any[] = [];
  filteredProducts: any[] = [];

  currentPage = 1;
  itemsPerPage = 8;
  totalItems = 0;
  totalPages = 1;

  isSearching = false;
  searchTerm = '';

  days = [
    { label: 'All', value: 0 },
    { label: 'Saturday', value: 1 },
    { label: 'Sunday', value: 2 },
    { label: 'Monday', value: 3 },
    { label: 'Tuesday', value: 4 },
    { label: 'Wednesday', value: 5 },
    { label: 'Thursday', value: 6 },
    { label: 'Friday', value: 7 }
  ];
  currnetWeek:string[]=[];
  selectedDay = 0;
  printTitle:string="";

  selectedProduct: any = null;
  showStockModal = false;
  stockErrors: string[] = [];

  @ViewChildren('stock_qty', { read: ElementRef })
  stockQtyInputs!: QueryList<ElementRef<HTMLInputElement>>;
  selectedItem: any;

  constructor(private readonly productService: ProductService) {
    this.saveSubject
      .pipe(debounceTime(500), takeUntil(this.destroy$))
      .subscribe(item => this.saveRow(item));
  }

  ngOnInit(): void {
    this.loadByDay(1);
    this.showModalItem = false;
    this.showModalAll = false;
    this.showPrintModal = false;
    this.currnetWeek = this.getFullWeek(new Date(),6);
    this.printTitle = "Menu Days";
    console.log(this.currnetWeek);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.saveSubject.complete();
  }

  get reservationDays() {
    return this.days.filter(day => day.value !== 0);
  }

  private normalizeTime(value: unknown, fallback: string): string {
    
    if (value === null || value === undefined || value === '') {
      return fallback;
    }

    const text = String(value).trim();

    const isoMatch = text.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/);
    if (isoMatch) {
      //removeDate
      return isoMatch[0].split('T')[1];
    }

    const spaceMatch = text.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})/);
    if (spaceMatch) {
      return `${spaceMatch[1]}T${spaceMatch[2]}`;
    }

    const timeMatch = text.match(/^(\d{2}:\d{2})/);
    if (timeMatch) {
      const today = new Date().toISOString().split('T')[0];
      return `${today}T${timeMatch[1]}`;
    }

    return fallback;
  }

  private parseRawMenuDays(item: any): any[] {
    let raw =
      item?.menue_days ??
      item?.MenueDays ??
      item?.menu_days ??
      item?.MenuDays ??
      item?.product_menu_days ??
      item?.productMenuDays ??
      item?.MenueDayId ??
      item?.menue_day_id ??
      item?.menu_day_id ??
      item?.meue_day_id ??
      item?.menue_day_ids ??
      item?.MenueDayIds ??
      item?.menu_day_ids;

    if (typeof raw === 'string') {
      const trimmed = raw.trim();

      if (!trimmed) {
        return [];
      }

      // New backend response: JSON schedules stored in MenueDayId.
      if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
        try {
          const parsed = JSON.parse(trimmed);
          return Array.isArray(parsed) ? parsed : [parsed];
        } catch (error) {
          console.error('Invalid menu schedule JSON:', error, trimmed);
        }
      }

      // Old backend response: "1,2,3".
      raw = trimmed.split(',').map(value => value.trim());
    }

    return Array.isArray(raw) ? raw : raw ? [raw] : [];
  }

  private normalizeMenuDays(item: any): ProductMenuDaySchedule[] {
    return this.parseRawMenuDays(item)
      .map((value: any, index: number): ProductMenuDaySchedule => ({
        menu_day_id: Number(
          value?.menu_day_id ??
          value?.menuDayId ??
          value?.menue_day_id ??
          value?.menueDayId ??
          value?.meue_day_id ??
          value?.id ??
          value
        ),
        start_time: this.normalizeTime(
          value?.start_time ?? value?.startTime,
          `${new Date().toISOString().split('T')[0]}T00:00`
        ),




        min_qty: Number(
          value?.min_qty ??
          value?.minQty ??
          0
        ),

        prod_qty: Number(
          value?.prod_qty ??
          value?.prodQty ??
          0
        ),

        max_qty: Number(
          value?.max_qty ??
          value?.maxQty ??
          0
        ),

        alloc_qty: Number(
          value?.alloc_qty ??
          value?.allocQty ??
          0
        ),



        end_time: this.normalizeTime(
          value?.end_time ?? value?.endTime,
          `${new Date().toISOString().split('T')[0]}T23:59`
        ),
        priority: Number(value?.priority ?? index + 1),
        is_active: value?.is_active ?? value?.isActive ?? true
      }))
      .filter(schedule =>
        Number.isFinite(schedule.menu_day_id) &&
        schedule.menu_day_id >= 1 &&
        schedule.menu_day_id <= 7 &&
        schedule.is_active
      )
      .filter((schedule, index, all) =>
        all.findIndex(x => x.menu_day_id === schedule.menu_day_id) === index
      )
      .sort((a, b) => a.priority - b.priority || a.menu_day_id - b.menu_day_id)
      .map((schedule, index) => ({
        ...schedule,
        priority: index + 1
      }));
  }

  private prepareProduct(item: any): any {
    const menuDays = this.normalizeMenuDays(item);
    const dayIds = menuDays.map(schedule => schedule.menu_day_id);

    return {
      ...item,
      menue_days: menuDays,
      menue_day_ids: dayIds,
      menue_day_id: dayIds[0] ?? 0,
      menue_days_text: this.getDaysText(dayIds),
      _dirty: false,
      _scheduleError: ''
    };
  }

  getDaysText(dayIds: number[] = []): string {
    if (!dayIds.length) {
      return 'No days';
    }

    return dayIds
      .map(id => this.days.find(day => day.value === Number(id))?.label)
      .filter((label): label is string => Boolean(label))
      .join(', ');
  }

  getMenuDay(
    item: any,
    dayId: number
  ): ProductMenuDaySchedule | undefined {
    return (item?.menue_days ?? []).find(
      (schedule: ProductMenuDaySchedule) =>
        Number(schedule.menu_day_id) === Number(dayId)
    );
  }

  isDaySelected(item: any, dayId: number): boolean {
    return Boolean(this.getMenuDay(item, dayId));
  }

  toggleProductDay(item: any, dayId: number, checked: boolean): void {
    const schedules: ProductMenuDaySchedule[] = Array.isArray(item.menue_days)
      ? [...item.menue_days]
      : [];

    if (checked) {
      const exists = schedules.some(schedule => schedule.menu_day_id === dayId);

      if (!exists) {
        const today = new Date().toISOString().split('T')[0];
        // schedules.push({
        //   menu_day_id: dayId,
        //   start_time: `${today}T00:00`,
        //   end_time: `${today}T23:59`,
        //   priority: schedules.length + 1,
        //   is_active: true
        // });

        schedules.push({

          menu_day_id: dayId,

          start_time:
            `${today}T00:00`,

          end_time:
            `${today}T23:59`,


          // ✅ كل يوم يبدأ بكمياته الخاصة
          min_qty: 0,

          prod_qty: 0,

          max_qty: 0,

          alloc_qty: 0,


          priority:
            schedules.length + 1,

          is_active: true

        });

      }
    } else {
      item.menue_days = schedules.filter(
        schedule => schedule.menu_day_id !== dayId
      );
    }

    if (checked) {
      item.menue_days = schedules;
    }

    this.rebuildDaySummary(item);
    this.markDirty(item);
    this.onQtyChange(item);
  }

  onMenuTimeChange(item: any): void {
    this.markDirty(item);
    this.onQtyChange(item);
  }

  private rebuildDaySummary(item: any): void {
    item.menue_days = (item.menue_days ?? [])
      .sort((a: ProductMenuDaySchedule, b: ProductMenuDaySchedule) =>
        a.priority - b.priority || a.menu_day_id - b.menu_day_id
      )
      .map((schedule: ProductMenuDaySchedule, index: number) => ({
        ...schedule,
        priority: index + 1
      }));

    item.menue_day_ids = item.menue_days.map(
      (schedule: ProductMenuDaySchedule) => schedule.menu_day_id
    );
    item.menue_day_id = item.menue_day_ids[0] ?? 0;
    item.menue_days_text = this.getDaysText(item.menue_day_ids);
  }

  private validateMenuDays(item: any): boolean {
    item._scheduleError = '';

    const schedules: ProductMenuDaySchedule[] = item?.menue_days ?? [];

    for (const schedule of schedules) {
      const dayName = this.days.find(
        day => day.value === schedule.menu_day_id
      )?.label ?? `Day ${schedule.menu_day_id}`;

      if (!schedule.start_time || !schedule.end_time) {
        item._scheduleError =
          `${dayName}: start time and end time are required.`;
        return false;
      }

      if (schedule.end_time <= schedule.start_time) {
        item._scheduleError =
          `${dayName}: end time must be after start time.`;
        return false;
      }
    }

    return true;
  }

  markDirty(item: any): void {
    item._dirty = true;
  }

  // onMaxQtyChange(item: any, value: any): void {

  //   const allocatedProduct =
  //     Number(item.prod_qty ?? 0);

  //   let maxQty =
  //     Number(value ?? 0);


  //   // ممنوع أقل من صفر
  //   if (maxQty < 0) {
  //     maxQty = 0;
  //   }


  //   // ✅ ممنوع Max يعدي Allocated Product
  //   if (maxQty > allocatedProduct) {
  //     maxQty = allocatedProduct;
  //   }


  //   item.max_qty = maxQty;

  //   this.markDirty(item);
  // }



  // onQtyChange(item: any): void {
  //   item.min_qty = Number(item.min_qty ?? 0);
  //   item.prod_qty = Number(item.prod_qty ?? 0);
  //   item.max_qty = Number(item.max_qty ?? 0);

  //   if (item.min_qty < 0) {
  //     item.min_qty = 0;
  //   }

  //   if (item.prod_qty < 0) {
  //     item.prod_qty = 0;
  //   }

  //   if (item.max_qty < item.min_qty) {
  //     item.max_qty = item.min_qty;
  //   }

  //   this.rebuildDaySummary(item);

  //   const invalidDay = item.menue_day_ids.some(
  //     (id: number) => id < 1 || id > 7
  //   );

  //   if (invalidDay) {
  //     item._scheduleError = 'Menu day must be between 1 and 7.';
  //     return;
  //   }

  //   if (!this.validateMenuDays(item)) {
  //     return;
  //   }

  //   this.saveSubject.next(item);
  // }

  // onQtyChange(item: any): void {

  //   item.min_qty =
  //     Number(item.min_qty ?? 0);

  //   item.prod_qty =
  //     Number(item.prod_qty ?? 0);

  //   item.max_qty =
  //     Number(item.max_qty ?? 0);


  //   if (item.min_qty < 0) {
  //     item.min_qty = 0;
  //   }


  //   if (item.prod_qty < 0) {
  //     item.prod_qty = 0;
  //   }


  //   if (item.min_qty > item.prod_qty) {
  //     item.min_qty = item.prod_qty;
  //   }

  //   if (item.max_qty > item.prod_qty) {
  //     item.max_qty = item.prod_qty;
  //   }

  //   if (item.max_qty < item.min_qty) {
  //     item.max_qty = item.min_qty;
  //   }


  //   this.rebuildDaySummary(item);

  //   const invalidDay = item.menue_day_ids.some(
  //     (id: number) => id < 1 || id > 7
  //   );

  //   if (invalidDay) {
  //     item._scheduleError =
  //       'Menu day must be between 1 and 7.';
  //     return;
  //   }

  //   if (!this.validateMenuDays(item)) {
  //     return;
  //   }

  //   this.saveSubject.next(item);
  // }

  onQtyChange(item: any): void {

    this.rebuildDaySummary(item);


    const invalidDay =
      item.menue_day_ids.some(
        (id: number) =>
          id < 1 || id > 7
      );


    if (invalidDay) {
      item._scheduleError =
        'Menu day must be between 1 and 7.';

      return;
    }


    if (!this.validateMenuDays(item)) {
      return;
    }


    // ✅ حفظ الـ Product بكل أيامه
    // وكل يوم يحتوي كمياته الخاصة
    this.saveSubject.next(item);
  }

  // private saveRow(item: any): void {
  //   // const menuDays: ProductMenuDaySchedule[] = (item.menue_days ?? []).map(
  //   //   (schedule: ProductMenuDaySchedule, index: number) => ({
  //   //     menu_day_id: Number(schedule.menu_day_id),
  //   //     start_time: schedule.start_time,
  //   //     end_time: schedule.end_time,
  //   //     priority: index + 1,
  //   //     is_active: true
  //   //   })
  //   // );

  //   const menuDays: ProductMenuDaySchedule[] =
  // (item.menue_days ?? []).map(
  //   (
  //     schedule: ProductMenuDaySchedule,
  //     index: number
  //   ) => ({

  //     menu_day_id:
  //       Number(schedule.menu_day_id),

  //     start_time:
  //       schedule.start_time,

  //     end_time:
  //       schedule.end_time,


  //     // ✅ كل يوم بكمياته
  //     min_qty:
  //       Number(schedule.min_qty ?? 0),

  //     prod_qty:
  //       Number(schedule.prod_qty ?? 0),

  //     max_qty:
  //       Number(schedule.max_qty ?? 0),

  //     alloc_qty:
  //       Number(schedule.alloc_qty ?? 0),


  //     priority:
  //       index + 1,

  //     is_active:
  //       true

  //   })
  // );


  //   const payload = {
  //     id: item.id,
  //     // min_qty: Number(item.min_qty ?? 0),
  //     // prod_qty: Number(item.prod_qty ?? 0),
  //     // max_qty: Number(item.max_qty ?? 0),
  //     menue_day_id: menuDays[0]?.menu_day_id ?? 0,
  //     menue_day_ids: menuDays.map(schedule => schedule.menu_day_id),
  //     menue_days: menuDays
  //   };

  //   this.productService.updateProductQty(payload).subscribe({
  //     next: () => {
  //       item._dirty = false;
  //       item._scheduleError = '';
  //       this.loadByDay(this.currentPage);
  //     },
  //     error: error => {
  //       console.error('Error updating product schedule:', error);
  //       this.loadByDay(this.currentPage);
  //     }
  //   });
  // }

  private saveRow(item: any): void {
    console.log("hihii");
    const menuDays =
      (item.menue_days ?? []).map(
        (
          schedule: ProductMenuDaySchedule,
          index: number
        ) => ({

          menu_day_id:
            Number(schedule.menu_day_id),

          start_time:
            this.getDayDate(schedule.start_time,schedule.menu_day_id),

          end_time:
            schedule.end_time,


          // ✅ كميات اليوم نفسه
          min_qty:
            Number(schedule.min_qty ?? 0),

          prod_qty:
            Number(schedule.prod_qty ?? 0),

          max_qty:
            Number(schedule.max_qty ?? 0),


          // ❌ متبعتش alloc_qty من الفرونت
          // الباك هو المسؤول عنه

          priority:
            index + 1,

          is_active:
            true

        })
      );


    const payload = {

      id:
        item.id,

      menue_day_id:
        menuDays[0]?.menu_day_id ?? 0,

      menue_day_ids:
        menuDays.map(
          (schedule: any) =>
            schedule.menu_day_id
        ),

      menue_days:
        menuDays
    };


    console.log(
      'MENU DAY QTY PAYLOAD:',
      payload
    );


    this.productService
      .updateProductQty(payload)
      .subscribe({

        next: () => {

          item._dirty = false;
          item._scheduleError = '';

        },

        error: error => {

          console.error(
            'Error updating product schedule:',
            error
          );

        }

      });
  }

  onDayChange(): void {
    this.currentPage = 1;
    this.loadByDay(1);
  }

  onSearch(event: Event): void {
    const input = event.target as HTMLInputElement;
    const term = (input.value ?? '').trim();

    if (!term) {
      this.isSearching = false;
      this.searchTerm = '';
      this.currentPage = 1;
      this.loadByDay(1);
      return;
    }

    this.isSearching = true;
    this.searchTerm = this.normalizeArabicText(term.toLowerCase());
    this.currentPage = 1;
    this.loadByDay(1);
  }

  private normalizeArabicText(text: string): string {
    return text
      .replace(/[أآإ]/g, 'ا')
      .replace(/ة/g, 'ه')
      .replace(/ى/g, 'ي')
      .replace(/ؤ/g, 'و')
      .replace(/ئ/g, 'ي');
  }

  loadByDay(page: number): void {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.currentPage = page;

    const request$ = this.isSearching && this.searchTerm
      ? this.productService.searchReservationProducts(
        this.searchTerm,
        page,
        this.itemsPerPage,
        this.selectedDay
      )
      : this.productService.getReservationProducts(page, this.selectedDay);

    request$.subscribe({
      next: (response: any) => {
        this.products = (response?.data ?? []).map(
          (item: any) => this.prepareProduct(item)
        );
        this.filteredProducts = [...this.products];
        this.setMeta(response);
        this.isLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        console.log("Filtered Products", this.filteredProducts);
      },
      error: error => {
        console.error('Error loading products:', error);
        this.isLoading = false;
      }
    });
  }

  private setMeta(response: any): void {
    const meta = response?.meta ?? {};

    const total = meta.total ?? meta.Total ?? 0;
    const lastPage =
      meta.lastPage ??
      meta.last_page ??
      meta.lastpage ??
      meta.totalPages ??
      meta.total_pages ??
      meta.pages ??
      0;

    this.totalItems = Number(total) || 0;

    const computed =
      Math.ceil(this.totalItems / Math.max(this.itemsPerPage, 1)) || 1;

    this.totalPages = Number(lastPage) || computed;
  }

  goToPage(page: number): void {
    if (
      page >= 1 &&
      page <= this.totalPages &&
      page !== this.currentPage
    ) {
      this.loadByDay(page);
    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.loadByDay(this.currentPage - 1);
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.loadByDay(this.currentPage + 1);
    }
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxVisiblePages = 5;
    const safeTotalPages = this.totalPages || 1;

    let startPage = Math.max(
      1,
      this.currentPage - Math.floor(maxVisiblePages / 2)
    );
    const endPage = Math.min(
      safeTotalPages,
      startPage + maxVisiblePages - 1
    );

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let page = startPage; page <= endPage; page++) {
      pages.push(page);
    }

    return pages;
  }

  getStartIndex(): number {
    if (this.totalItems === 0) {
      return 0;
    }

    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  getEndIndex(): number {
    return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  }

  openStockModal(product: any): void {
    this.selectedProduct = JSON.parse(JSON.stringify(product));
    this.stockErrors = [];
    this.showStockModal = true;
  }

  closeStockModal(): void {
    this.selectedProduct = null;
    this.stockErrors = [];
    this.showStockModal = false;
  }

  saveStock(): void {
    if (!this.validateStock()) {
      return;
    }

    const inputElements = this.stockQtyInputs.toArray();
    const stockPayload: Array<{
      id: number;
      alloc_qty: number;
      stock_qty: number;
    }> = [];

    for (let index = 0; index < this.selectedProduct.stock.length; index++) {
      const stock = this.selectedProduct.stock[index];
      const input = inputElements[index]?.nativeElement;
      const stockQty = input
        ? Number.parseFloat(input.value) || 0
        : Number(stock.alloc_qty ?? 0);

      stockPayload.push({
        id: stock.id,
        alloc_qty: Number(stock.alloc_qty ?? 0),
        stock_qty: stockQty
      });
    }

    const payload = {
      product_id: this.selectedProduct.id,
      stock: stockPayload
    };

    this.productService
      .updateProductStock(payload.product_id, payload)
      .subscribe({
        next: () => {
          this.showStockModal = false;
          this.loadByDay(this.currentPage);
        },
        error: error => {
          console.error('Error saving stock:', error);
        }
      });
  }

  validateStock(): boolean {
    this.stockErrors = [];
    const inputElements = this.stockQtyInputs.toArray();
    let valid = true;

    if (!this.selectedProduct?.stock) {
      return false;
    }

    for (let index = 0; index < this.selectedProduct.stock.length; index++) {
      const stock = this.selectedProduct.stock[index];
      const input = inputElements[index]?.nativeElement;
      const stockedValue = input
        ? Number.parseFloat(input.value) || 0
        : 0;
      const allocated = Number(stock.alloc_qty ?? 0);

      if (stockedValue < allocated) {
        this.stockErrors[index] =
          `Stocked quantity must be at least ${allocated}.`;
        valid = false;
      } else {
        this.stockErrors[index] = '';
      }
    }

    return valid;
  }

  onPickerSaved(payload: PickerSavedPayload): void {
    const selectedDayIds = payload.days?.length
      ? payload.days
      : payload.day
        ? [payload.day]
        : [];

    const menuDays =
      payload.menu_days?.length
        ? payload.menu_days
        : selectedDayIds.map(
          (dayId, index) => ({

            menu_day_id: dayId,

            start_time: '00:00',

            end_time: '23:59',


            // ✅ كل يوم له كمياته
            min_qty: 0,

            prod_qty: 0,

            max_qty: 0,

            alloc_qty: 0,


            priority: index + 1,

            is_active: true

          })
        );


    const requestPayload = {
      ...payload,
      day: selectedDayIds[0] ?? 0,
      days: selectedDayIds,
      menu_days: menuDays
    };

    this.productService.updateProductType(requestPayload).subscribe({
      next: () => this.loadByDay(1),
      error: error => {
        console.error('Error adding products to menu days:', error);
        this.loadByDay(1);
      }
    });
  }

  handleImageError(event: Event): void {
    const image = event.target as HTMLImageElement;
    image.src = 'assets/images/logo/logo.svg';
  }

  onDayMaxQtyChange(
    item: any,
    schedule: ProductMenuDaySchedule,
    value: any
  ): void {

    const prodQty =
      Number(schedule.prod_qty ?? 0);

    let maxQty =
      Number(value ?? 0);


    if (maxQty < 0) {
      maxQty = 0;
    }


    if (maxQty > prodQty) {
      maxQty = prodQty;
    }


    schedule.max_qty =
      maxQty;


    this.markDirty(item);
  }

  onDayQtyChange(
    item: any,
    schedule: ProductMenuDaySchedule
  ): void {

    schedule.min_qty =
      Number(schedule.min_qty ?? 0);

    schedule.prod_qty =
      Number(schedule.prod_qty ?? 0);

    schedule.max_qty =
      Number(schedule.max_qty ?? 0);


    if (schedule.min_qty < 0) {
      schedule.min_qty = 0;
    }


    if (schedule.prod_qty < 0) {
      schedule.prod_qty = 0;
    }


    // مينفعش تقل الكمية عن المحجوز فعلاً
    if (
      schedule.prod_qty <
      Number(schedule.alloc_qty ?? 0)
    ) {

      schedule.prod_qty =
        Number(schedule.alloc_qty ?? 0);
    }


    if (
      schedule.min_qty >
      schedule.prod_qty
    ) {

      schedule.min_qty =
        schedule.prod_qty;
    }


    if (
      schedule.max_qty >
      schedule.prod_qty
    ) {

      schedule.max_qty =
        schedule.prod_qty;
    }


    if (
      schedule.max_qty <
      schedule.min_qty
    ) {

      schedule.max_qty =
        schedule.min_qty;
    }


    this.markDirty(item);

    this.onQtyChange(item);
  }

  removeFromMenuDay(item: any): void {

    console.log(item);

    // this.showModal = true;

    // this.popupModalArgs.title = "Warning";
    // this.popupModalArgs.message = `Are you sure you want to remove ${item.name} from menu days?`
    // this.popupModalArgs.confirmLabel = "REMOVE";
    // this.popupModalArgs.cancelLabel = "CANCEL";


    // if (!this.confirmDelete) {
    //   return;
    // }
    // //cleanup 
    // this.confirmDelete = false;

    this.productService
      .removeProductFromMenuDay(item.id)
      .subscribe({

        next: (res) => {

          console.log(
            'Removed from menu day:',
            res
          );
          this.showModalItem = false;


          this.loadByDay(this.currentPage);

        },


        error: (err) => {

          console.error(
            'Remove menu day error:',
            err
          );
          this.showModalItem = false;
          this.showModalConfirm = true;

          this.popupModalArgs.title = "Failed";
          this.popupModalArgs.message = `Failed to remove ${item.name} from Menu days!`;
          this.popupModalArgs.confirmLabel = "confirm";
        }

      });



  }

  removeAllFromMenuDay(): void {

    // this.showModalAll = true;

    // this.popupModalArgs.title = "Warning";
    // this.popupModalArgs.message = "Are you sure you want to remove all products from menu days?"
    // this.popupModalArgs.confirmLabel = "REMOVE ALL";
    // this.popupModalArgs.cancelLabel = "CANCEL";


    // if (!this.confirmDelete) {
    //   return;
    // }
    // //cleanup 
    // this.confirmDelete = false;

    this.productService
      .removeAllProductsFromMenuDay()
      .subscribe({

        next: (res) => {

          console.log(
            'All menu days removed:',
            res
          );

          this.showModalAll = false;
          this.showModalConfirm = true;

          this.popupModalArgs.title = "Success";
          this.popupModalArgs.message = `All Items were removed from the Menu days!`
          this.popupModalArgs.confirmLabel = "Ok";
          this.popupModalArgs.cancelLabel = "CANCEL";

          this.loadByDay(1);

        },


        error: (err) => {

          console.error(
            'Remove all menu days error:',
            err
          );


          this.showModalConfirm = true;

          this.popupModalArgs.title = "Failed";
          this.popupModalArgs.message = `Failed to remove items!`
          this.popupModalArgs.confirmLabel = "Confirm";

        }

      });

  }

  prepPopupModalItem(item: any): void {
    this.selectedItem = item;
    this.showModalItem = true;
    this.popupModalArgs.title = "Warning";
    this.popupModalArgs.message = `Are you sure you want to remove ${item.name} from menu days?`
    this.popupModalArgs.confirmLabel = "REMOVE";
    this.popupModalArgs.cancelLabel = "CANCEL";

  }

  prepPopupModalAll(): void {
    this.showModalAll = true;

    this.popupModalArgs.title = "Warning";
    this.popupModalArgs.message = "Are you sure you want to remove all products from menu days?"
    this.popupModalArgs.confirmLabel = "REMOVE ALL";
    this.popupModalArgs.cancelLabel = "CANCEL";
  }

  sendToPrint() {
    console.log("FilteredProducts", this.filteredProducts);
    //console.log("All Products",this.products);
    //console.log(this.filteredProducts[0].id);
    this.ordersPrint = [];

    this.printTitle = this.getPrintTitle();

    //const currPage = this.currentPage;
    for(let i = 1 ; i <= this.totalPages ; i++){

      

      this.loadByDay(i);
      //console.log(`CurrPage${i}`,this.filteredProducts);

      for (let product of this.filteredProducts) {
        var menuDayItem: ProductMenuDayForPrint = {} as ProductMenuDayForPrint;
        menuDayItem.product_name = product.name;

        menuDayItem.product_code = product.barcode;

        menuDayItem.days_quantity_sat = product.menue_days?.find((day:ProductMenuDaySchedule)=>day?.menu_day_id == 1)?.prod_qty?? 0;

        menuDayItem.days_quantity_sun = product.menue_days?.find((day:ProductMenuDaySchedule)=>day?.menu_day_id == 2)?.prod_qty?? 0;

        menuDayItem.days_quantity_mon = product.menue_days?.find((day:ProductMenuDaySchedule)=>day?.menu_day_id == 3)?.prod_qty?? 0;

        menuDayItem.days_quantity_tues = product.menue_days?.find((day:ProductMenuDaySchedule)=>day?.menu_day_id == 4)?.prod_qty?? 0;

        menuDayItem.days_quantity_wed = product.menue_days?.find((day:ProductMenuDaySchedule)=>day?.menu_day_id == 5)?.prod_qty?? 0;

        menuDayItem.days_quantity_thurs = product.menue_days?.find((day:ProductMenuDaySchedule)=>day?.menu_day_id == 6)?.prod_qty?? 0;

        menuDayItem.days_quantity_fri = product.menue_days?.find((day:ProductMenuDaySchedule)=>day?.menu_day_id == 7)?.prod_qty?? 0;

        this.ordersPrint.push(menuDayItem);
      }
  }
    console.log("ToPrintProducts", this.ordersPrint);
    this.loadByDay(1);
    this.showPrintModal = true;
  }

  // prepMenuDaysToPrint(day:any, day_text:string){
  //   if(day== null || day ===""){
  //     return "";
  //   }else{
  //     let starttime = day.start_time.split("T")[1];
  //     let endtime = day.end_time.split("T")[1];
  //     let min_qty = day.min_qty;
  //     let max_qty = day.max_qty;
  //     let prod_qty = day.prod_qty;
  //     let alloc_qty = day.alloc_qty;

  //     if(day_text == null || day_text ===""){
  //       day_text = "-"
  //     }

  //     return `${day_text}\n
  //             ${starttime} -> ${endtime} | ${min_qty} - ${prod_qty} - ${max_qty} - ${alloc_qty}`;
  //   }
  // }

getFullWeek(
  date: Date = new Date(),
  weekStartsOn: number = 1 // 0 = Sunday, 1 = Monday, ... 6 = Saturday
): string[] {
  // Normalize to midnight so time of day doesn't matter
  const current = new Date(date.getFullYear(), date.getMonth(), date.getDate(),12);

  // How many days have passed since the start of the week (0-6)
  const daysSinceStart = (current.getDay() - weekStartsOn + 7) % 7;

  // Go back to the first day of the week
  const weekStart = new Date(current);
  weekStart.setDate(current.getDate() - daysSinceStart);

  // Build all 7 days
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(weekStart);
    d.setDate(weekStart.getDate() + i);
    return d.toISOString();
  });
}

getDayDate(time:string, menudayid:number):string{
  //console.log(time,this.currnetWeek[menudayid-1]);
  const newdate = `${this.currnetWeek[menudayid-1].split('T')[0]}T${time}`;
  console.log(newdate);
  return newdate;
}


getPrintTitle(){
  return `Menu Days From ${formatDate(this.currnetWeek[0],'d MMM y', 'en-US')} -> ${formatDate(this.currnetWeek[this.currnetWeek.length-1],'d MMM y', 'en-US')}`
}
}
